import { Vec3 } from '../math/Vec3';
import type { SimulationConfig, VisibilityState } from '../simulation/types';

export const LASER_BASE_PRESETS = {
  COMPACT: {
    radius: 0.21,
    label: 'BASE · COMPACTA · Ø42 CM',
  },
  ORIGINAL: {
    radius: 0.55,
    label: 'BASE · ORIGINAL · Ø110 CM',
  },
} as const;

export const DEFAULT_CONFIG: SimulationConfig = {
  cubeSize: new Vec3(0.3, 0.3, 0.3),
  meshCount: 24,
  meshDensity: 7,
  minimumMeshDistance: 0.0005,
  filamentRadius: 0.00012,
  meshPattern: 'radial',
  meshStrategy: 'parallel',
  orientationRandomness: 0.12,
  curvature: 0.006,
  logicalLaserCount: 2_000,
  renderedRayLimit: 120,
  hemisphereRadius: LASER_BASE_PRESETS.COMPACT.radius,
  laserMinAngle: 0,
  laserMaxAngle: Math.PI / 2,
  occlusionEnabled: true,
  scatteringCoefficient: 0.72,
  projectionFigure: 'HEART',
  projectionTolerance: 0.005,
  seed: 41_337,
};

export const DEFAULT_VISIBILITY: VisibilityState = {
  meshes: true,
  projectionMeshes: false,
  lasers: true,
  projectionRays: false,
  desiredRays: false,
  intersections: true,
  blockedRays: true,
  target: false,
  reconstructedImage: false,
};

export const LAB_PRESETS: Record<string, Partial<SimulationConfig>> = {
  P0: {
    ...DEFAULT_CONFIG,
    meshCount: 6,
    meshDensity: 5,
    meshPattern: 'cartesian',
    orientationRandomness: 0,
    curvature: 0,
    logicalLaserCount: 16,
    renderedRayLimit: 16,
  },
  INTERACTIVE: {
    meshCount: 24,
    meshDensity: 7,
    logicalLaserCount: 2_000,
    renderedRayLimit: 120,
  },
  DEBUG: {
    meshCount: 100,
    meshDensity: 6,
    logicalLaserCount: 100,
    renderedRayLimit: 100,
  },
  SMALL: {
    meshCount: 500,
    meshDensity: 8,
    logicalLaserCount: 1_000,
    renderedRayLimit: 160,
  },
  MEDIUM: {
    meshCount: 2_000,
    meshDensity: 10,
    logicalLaserCount: 5_000,
    renderedRayLimit: 180,
  },
  EXPERIMENTAL: {
    meshCount: 10_000,
    meshDensity: 12,
    logicalLaserCount: 10_000,
    renderedRayLimit: 200,
  },
};
